module.exports = __webpack_public_path__ + "img/davich-symbol-motif.779361ec.png";